import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import useTranslation from '../../hooks/useTranslation';

const MainLayout = () => {
  const { lang } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <div className="hidden lg:block lg:fixed lg:inset-y-0 lg:z-50"
        style={{ [lang === 'ar' ? 'right' : 'left']: 0 }}>
        <Sidebar />
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      <div
        className="flex-1 lg:ml-64"
        style={{ [lang === 'ar' ? 'marginRight' : 'marginLeft']: '16rem' }}
      >
        <Header onMenuClick={toggleSidebar} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
